import "./toolbar.scss";

import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import { immutableRecords } from "../../types";
import ToolbarPopoverListItem from "./ToolbarPopoverListItem";

const ToolbarPopoverListGroup = props => (
  <div className={`toolbarPopoverListGroup${props.numItemsInRow > 1 ? ` col-${props.numItemsInRow}` : ``}`}>
    {props.label ? <div className="toolbarPopoverListGroupLabel">{props.label}</div> : null}
    {props.children
      .map((c, index) => (
        <ToolbarPopoverListItem
          key={index}
          {...c.toObject()}
          showIcon={props.showIcons}
          showSelectedIcon={props.showSelectedIcon}
          showSelectedBackground={props.showSelectedBackground}
          showShortcuts={props.showShortcuts}
          iconClass={props.iconClass}
          onClick={props.onClick}
          showDescription={props.showDescription}
        />
      ))
      .toArray()}
  </div>
);

ToolbarPopoverListGroup.defaultProps = {
  numItemsInRow: 1
};

ToolbarPopoverListGroup.propTypes = {
  label: PropTypes.string,
  children: ImmutablePropTypes.listOf(PropTypes.instanceOf(immutableRecords.PopoverMenuItemRecord)),
  showIcons: PropTypes.bool,
  showSelectedIcon: PropTypes.bool,
  showSelectedBackground: PropTypes.bool,
  showShortcuts: PropTypes.bool,
  iconClass: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  numItemsInRow: PropTypes.number.isRequired,
  showDescription: PropTypes.bool
};

export default ToolbarPopoverListGroup;
